import { msg } from "@omegagrid/localize";
import { NodeSource, TreeAdapter, TreeAdapterParams, TreeOptions, TreeSource } from "@omegagrid/tree";
import { Service } from "@reporting/rp-app-host";
import { ModuleCode } from "@reporting/rp-types/accounting";
import { PeriodDimensionType, PeriodItem } from "@reporting/rp-types/analytics";

export class PeriodAdapter extends TreeAdapter {

	private items: NodeSource[];
	public accounting: number;

	constructor(
		private analyticsClient: Service,
		private module: ModuleCode,
		private type: PeriodDimensionType,
		private options?: Partial<TreeOptions>
	) { super() }

	async getStaticPeriodTree() {
		const data = await this.analyticsClient.get<PeriodItem[]>(`periodTree`, {
			m: this.module,
			type: this.type,
			accounting: this.accounting
		});
		return data.map(item => ({
			k: item.id_period,
			v: item.period,
			l: item.level,
			collapsed: true
		}));
	}

	async getTree(params: TreeAdapterParams): Promise<TreeSource> {
		if (this.items != null) return this.items;

		try {
			this.items = await this.getStaticPeriodTree();
		} catch (error) {
			return [{
				k: null,
				v: error,
				icon: {icon: "hexagon-exclamation", color: 'red'}
			}];
		}

		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {
			selectMode: 'multiple'
		};
	}

}
